import React from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import ConfiguratorContentAccordion from './ConfiguratorContentAccordion.react';
import * as DocumentStorageActions from '../actions/documentStorage';
import * as ConfiguratorActions from '../actions/configurator';
import {FormattedMessage, injectIntl} from 'react-intl';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import * as ConfiguratorManagerConstants from '../ConfiguratorManager';
import Modal from 'react-modal';
import * as CartActions from '../actions/cart';
import {push} from "react-router-redux";

class ConfiguratorRightCol extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.handleSelect = this.handleSelect.bind(this);
        this.openModalDownload = this.openModalDownload.bind(this);
        this.closeModalDownload = this.closeModalDownload.bind(this);
        this.openModalCopy = this.openModalCopy.bind(this);
        this.closeModalCopy = this.closeModalCopy.bind(this);
        this.openCopyWarningModal = this.openCopyWarningModal.bind(this);
        this.closeCopyWarningModal = this.closeCopyWarningModal.bind(this);
        this.addToCart = this.addToCart.bind(this);
        this.openPdf = this.openPdf.bind(this);

        this.state = {
            tabIndex: 0,
            modalDownloadIsOpen: false,
            modalCopyIsOpen: false,
            langCopy: false,
            didShowCopyWarning: false,
            copyWarningModalOpen: false,
            approvalSuccessModalOpen:false
        }
    }

    static get defaultProps() {
        return {
            ConfiguratorManager: {}
        }
    }

    handleSelect(index, last) {

        const newState = {
            ...this.state,
            tabIndex: index,
        };

        this.setState(newState);
    }

    closeModalDownload() {
        this.setState({modalDownloadIsOpen: false});
    }

    openModalDownload() {
        this.setState({modalDownloadIsOpen: true});
    }

    closeModalCopy() {
        this.setState({modalCopyIsOpen: false});
    }

    openModalCopy() {
        this.setState({modalCopyIsOpen: true});
    }

    openCopyWarningModal() {
        this.setState({copyWarningModalOpen: true});
    }

    closeCopyWarningModal() {
        this.setState({copyWarningModalOpen: false});
    }

    addToCart(documentStorageId) {
        const {dispatch, validatePage} = this.props;
        dispatch(CartActions.updateItem(documentStorageId, 1));
        this.closeModalDownload();
    }

    openPdf(link) {
        this.closeModalDownload();
        window.open(link, '_blank');
    }

    requestApproval(documentStorageId) {
        const {dispatch, validatePage} = this.props;
        dispatch(CartActions.requestApprovalForItem(documentStorageId));
        this.closeModalDownload();
    }

    openApprovalSuccess() {
        this.setState({approvalSuccessModalOpen: true});
    }

    closeApprovalSuccess() {
        const {dispatch, validatePage} = this.props;
        dispatch(DocumentStorageActions.fetchDocumentStorages())
        dispatch(CartActions.receiveApprovalSuccessHide())
    }

    closeConfigurator() {
        const {dispatch, validatePage} = this.props;
        dispatch(push('/dashboard'));
    }



    render() {

        let {ConfiguratorManager, validatePage} = this.props;

        const storageTitle = ConfiguratorManager.getDocumentStorageTitle();
        const storageId = ConfiguratorManager.getStorageId();
        const currentPageIndex = ConfiguratorManager.getCurrentPageIndex();
        const docId= ConfiguratorManager.getDocumentId();

        let additionalLangAvailable = false;
        let locales = [];
        let localeValue = null;
        let additionalLangLabel = null;
        let additionalLangId = null;
        let additionalLangMessage = '';
        localeValue = ConfiguratorManager.getDocumentStorageLocale();
        ConfiguratorManager.getDocumentEnabledLocales().map(locale => {
            if (localeValue != locale) {
                additionalLangId = locale;
                additionalLangLabel = "LANGUAGE_" + locale;
                if (additionalLangId == 'de_DE') {
                    additionalLangMessage = <p><FormattedMessage id="SUGGEST_LANG_COPY_DE"/></p>
                } else if (additionalLangId == 'en_GB') {
                    additionalLangMessage = <p><FormattedMessage id="SUGGEST_LANG_COPY_EN"/></p>
                }
            }
            locales.push(
                {"id": locale, "label": "LANGUAGE_" + locale}
            )
        });
        if (locales.length > 1) {
            additionalLangAvailable = true;
        }

        const pdfLink = '/api/pdfproduct/send-zip/' + storageId + '?webquality=0&printmarks=1';
        const pdfLinkCurrentPage = '/api/pdfproduct/send/' + storageId + '/' + currentPageIndex + '?webquality=1&printmarks=1';
        const pdfLinkWebversion = '/api/pdfproduct/send/' + storageId + '?webquality=1&printmarks=1';

        const productGroupedElements = ConfiguratorManager.getContentGroupElements(ConfiguratorManagerConstants.CONTENT_ELEMENT_TYPE_PRODUCT);
        const mediaGroupedElements = ConfiguratorManager.getContentGroupElements(ConfiguratorManagerConstants.CONTENT_ELEMENT_TYPE_MEDIA);

        const isUserPrintable = ConfiguratorManager.isUserPrintable();
        const isPrintshopPrintable = ConfiguratorManager.isPrintshopPrintable();
        const isWebVersionAvailable = ConfiguratorManager.isWebVersionAvailable();
        const isApproval = ConfiguratorManager.isApproval();
        let showApprovalSuccess = ConfiguratorManager.showApprovalSuccess();

        const intl = this.props.intl;
        const currentLocale = intl.locale.replace('-', '_'); // de-DE -> de_DE

        let blockSelfPrint = null;
        let blockWebVersion = null;

        if (isUserPrintable) {
            blockSelfPrint = <div>
                <h3><FormattedMessage id="LABEL_SELF_PRINT"/></h3>
                <p><FormattedMessage id="TEXT_INTRO_SELF_PRINT"/></p>
                <a onClick={() => {
                    this.openPdf(pdfLink)
                }} role="button" className="btn btn-success">
                    <i className="material-icons">picture_as_pdf</i><FormattedMessage
                    id="LABEL_DOWNLOAD_PRINTABLE_PDF"/>
                </a>
            </div>;
        }

        let blockToCart = <div>
            <h3><FormattedMessage id="LABEL_COLLECT_FOR_CART"/></h3>
            <p><FormattedMessage id="TEXT_COLLECT_FOR_CART"/></p>

            <a onClick={() => {
                this.addToCart(storageId)
            }} role="button" className="btn btn-success">
                <i className="material-icons">add_shopping_cart</i><FormattedMessage id="LABEL_CART_ADD"/>
            </a>
        </div>;

        if (isPrintshopPrintable) {
            if (this.state.langCopy === true || additionalLangAvailable === false) {
                if (ConfiguratorManager.hasModifiedElements() && this.state.didShowCopyWarning === false && (docId===122 || docId===124 || docId===227 || docId===226)) {
                //TODO: fix above
                    blockToCart = <div>
                        <h3><FormattedMessage id="LABEL_COLLECT_OR_SEND_TO_PRINTSHOP"/></h3>
                        <p><FormattedMessage id="TEXT_COLLECT_OR_SEND_TO_PRINTSHOP"/></p>
                        <Link onClick={() => {
                            this.openCopyWarningModal();
                        }} role="button" className="btn btn-success">
                            <i className="material-icons">add_shopping_cart</i><FormattedMessage id="LABEL_CART_ADD"/>
                        </Link>
                    </div>;
                } else {
                    blockToCart = <div>
                        <h3><FormattedMessage id="LABEL_COLLECT_OR_SEND_TO_PRINTSHOP"/></h3>
                        <p><FormattedMessage id="TEXT_COLLECT_OR_SEND_TO_PRINTSHOP"/></p>
                        <Link onClick={() => {
                            this.addToCart(storageId);
                        }} role="button" className="btn btn-success" to="/cart">
                            <i className="material-icons">add_shopping_cart</i><FormattedMessage id="LABEL_CART_ADD"/>
                        </Link>
                    </div>;
                }
            } else {
                blockToCart = <div>
                    <h3><FormattedMessage id="LABEL_COLLECT_OR_SEND_TO_PRINTSHOP"/></h3>
                    <p><FormattedMessage id="TEXT_COLLECT_OR_SEND_TO_PRINTSHOP"/></p>
                    <Link onClick={() => {
                        if (additionalLangAvailable == true && this.state.langCopy == false) {
                            this.openModalCopy();
                        }
                        this.addToCart(storageId);
                    }} role="button" className="btn btn-success">
                        <i className="material-icons">add_shopping_cart</i><FormattedMessage id="LABEL_CART_ADD"/>
                    </Link>
                </div>;
            }
        } else {
            blockToCart='';
        }

        if (isWebVersionAvailable) {
            blockWebVersion = <div>
                <h3><FormattedMessage id="LABEL_WEBVERSION_DOWNLOAD"/></h3>
                <p><FormattedMessage id="TEXT_WEBVERSION_DOWNLOAD"/></p>
                <a href={pdfLinkWebversion} role="button" className="btn btn-success" target="_blank">
                    <i className="material-icons">picture_as_pdf</i><FormattedMessage id="LABEL_WEBVERSION_DOWNLOAD"/>
                </a>
            </div>;
        }


        let colRightTabs =  <Tabs onSelect={this.handleSelect} selectedIndex={this.state.tabIndex}>
            <TabList>
                <Tab><FormattedMessage id="LABEL_PRODUCTS"/></Tab>
                <Tab><FormattedMessage id="LABEL_MEDIA_ELEMENTS"/></Tab>
            </TabList>
            <TabPanel className="configurator-right-col-content">
                <ConfiguratorContentAccordion groupedContentElements={productGroupedElements}
                                              ConfiguratorManager={ConfiguratorManager}
                                              currentLocale={currentLocale}/>
            </TabPanel>
            <TabPanel className="configurator-right-col-content">
                <ConfiguratorContentAccordion groupedContentElements={mediaGroupedElements}
                                              ConfiguratorManager={ConfiguratorManager}
                                              currentLocale={currentLocale}/>
            </TabPanel>
        </Tabs>;

        let colRightAction = <div className="btn-group-vertical" role="group" aria-label="Dokument ansehen">
            <a onClick={() => {
                validatePage(ConfiguratorManager.getPageId(), () => {
                    this.openPdf(pdfLinkCurrentPage)
                })
            }} role="button" className="btn btn-info btn-block">
                <i className="material-icons">visibility</i><FormattedMessage id="LABEL_SITE_PREVIEW"/>
            </a>
            <a role="button" className="btn btn-primary btn-block" onClick={() => {
                validatePage(ConfiguratorManager.getPageId(), this.openModalDownload)
            }}>
                <i className="material-icons">picture_as_pdf</i><FormattedMessage
                id="LABEL_DOWNLOAD_CONFIGURATOR_PDF"/>
            </a>
        </div>;

        let modalDownloadHeader = <div className="modal-header">
            <button type="button" className="close" onClick={this.closeModalDownload}>
                <span aria-hidden="true">&times;</span>
                <span className="sr-only"><FormattedMessage id="LABEL_CLOSE"/></span>
            </button>
            <h4 className="modal-title"><FormattedMessage id="LABEL_DOWNLOAD_PDF_OR_SEND_TO_PRINTSHOP"/>
            </h4>
        </div>;

        let modalDownloadTextId = <FormattedMessage id="TEXT_INTRO_DOWNLOAD_PDF_OR_SEND_TO_PRINTSHOP"/>;

        let blockApproval='';
        let blockSaveAndClose='';
        if (isApproval) {

            colRightAction = <div className="btn-group-vertical" role="group" aria-label="Dokument ansehen">
                <a role="button" className="btn btn-primary btn-block" onClick={() => {
                    validatePage(ConfiguratorManager.getPageId(), this.openModalDownload)
                }}>
                    <i className="material-icons">skip_next</i><FormattedMessage
                    id="LABEL_NEXT"/>
                </a>
            </div>;

            modalDownloadHeader = <div className="modal-header">
                <button type="button" className="close" onClick={this.closeModalDownload}>
                    <span aria-hidden="true">&times;</span>
                    <span className="sr-only"><FormattedMessage id="LABEL_CLOSE"/></span>
                </button>
                <h4 className="modal-title"><FormattedMessage id="LABEL_APPROVAL_PROCESS"/>
                </h4>
            </div>;

            modalDownloadTextId = <FormattedMessage id="TEXT_INTRO_APPROVAL_PROCESS"/>;

            blockWebVersion = '';
            blockToCart='';
            blockSelfPrint='';
            blockSaveAndClose = <div>
                <h3><FormattedMessage id="LABEL_SAVE_CLOSE"/></h3>
                <p><FormattedMessage id="TEXT_SAVE_CLOSE"/></p>

                <a onClick={() => {
                    this.closeConfigurator()
                }} role="button" className="btn btn-success">
                    <i className="material-icons">save</i><FormattedMessage id="LABEL_SAVE_CLOSE"/>
                </a>
            </div>;
            blockApproval = <div>
                <h3><FormattedMessage id="LABEL_REQUEST_APPROVAL"/></h3>
                <p><FormattedMessage id="TEXT_REQUEST_APPROVAL"/></p>

                <a onClick={() => {
                    this.requestApproval(storageId)
                }} role="button" className="btn btn-success">
                    <i className="material-icons">done_all</i><FormattedMessage id="LABEL_REQUEST_APPROVAL"/>
                </a>
            </div>;


        }

        return (
            <div className="configurator-right-col">
                {colRightTabs}

                {colRightAction}

                <Modal
                    className="Modal__Bootstrap modal-dialog"
                    closeTimeoutMS={150}
                    isOpen={this.state.modalDownloadIsOpen}
                    onRequestClose={this.closeModalDownload}
                >
                    <div className="modal-content">
                        {modalDownloadHeader}

                        <div className="modal-body">
                            <div>
                                {modalDownloadTextId}
                            </div>
                            {blockSelfPrint}
                            {blockToCart}
                            {blockWebVersion}
                            {blockApproval}
                            {blockSaveAndClose}
                        </div>

                        <div className="modal-footer">

                        </div>
                    </div>
                </Modal>
                <Modal
                    className="Modal__Bootstrap modal-dialog"
                    closeTimeoutMS={150}
                    isOpen={this.state.modalCopyIsOpen}
                    onRequestClose={this.closeModalCopy}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={this.closeModalCopy}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only"><FormattedMessage id="LABEL_CLOSE"/></span>
                            </button>
                            <h4 className="modal-title">Dieses Dokument ist noch in einer weiteren Sprache
                                verfügbar</h4>
                        </div>
                        <div className="modal-body">
                            <div>
                                {additionalLangMessage}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <Link onClick={() => {
                                const newState = {
                                    ...this.state,
                                    langCopy: true,
                                };
                                this.setState(newState, function () {
                                        this.closeModalCopy();
                                        this.closeModalDownload();
                                        let {dispatch} = this.props;
                                        dispatch(
                                            DocumentStorageActions.copyDocumentStorage(storageId, storageTitle + '-' + additionalLangId, additionalLangId, true)
                                        );

                                    }
                                );

                            }} role="button" className="btn btn-success">
                                Ja
                            </Link>
                            <Link onClick={() => {
                                this.closeModalCopy();
                                this.closeModalDownload();
                            }} role="button" className="btn btn-success" to="/cart">
                                Nein
                            </Link>
                        </div>
                    </div>
                </Modal>
                <Modal
                    className="Modal__Bootstrap modal-dialog"
                    closeTimeoutMS={150}
                    isOpen={this.state.copyWarningModalOpen}
                    onRequestClose={this.closeCopyWarningModal}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={this.closeCopyWarningModal}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only"><FormattedMessage id="LABEL_CLOSE"/></span>
                            </button>
                            <h4 className="modal-title"><FormattedMessage id="LABEL_WARNING"/></h4>
                        </div>
                        <div className="modal-body">
                            <p><FormattedMessage id="TEXT_COPY_HAS_MODIFIED_ELEMENTS"/></p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default"
                                    onClick={() => {
                                        const newState = {
                                            ...this.state,
                                            didShowCopyWarning: true,
                                        };
                                        this.setState(newState);
                                        this.closeCopyWarningModal();
                                    }}>
                                <FormattedMessage id="LABEL_CLOSE"/></button>
                        </div>
                    </div>
                </Modal>
                <Modal
                    className="Modal__Bootstrap modal-dialog"
                    closeTimeoutMS={150}
                    isOpen={showApprovalSuccess}
                    onRequestClose={this.closeApprovalSuccess}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={() => {
                                this.closeApprovalSuccess()
                            }}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only"><FormattedMessage id="LABEL_CLOSE"/></span>
                            </button>
                            <h4 className="modal-title"><FormattedMessage id="LABEL_APPOVAL_SUCCES"/></h4>
                        </div>
                        <div className="modal-body">
                            <p><FormattedMessage id="TEXT_APPOVAL_SUCCES"/></p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default"
                                    onClick={() => {
                                        this.closeApprovalSuccess()
                                    }}>
                                <FormattedMessage id="LABEL_CLOSE"/></button>
                        </div>
                    </div>
                </Modal>




            </div>
        );
    }
}

export default connect()(injectIntl(ConfiguratorRightCol));



// WEBPACK FOOTER //
// ./src/js/components/ConfiguratorRightCol.react.jsx